<template>
    <div class="topbar-container">
        <div class="scrollbar-container">
            <div class="line"></div>
            <validation-observer v-slot="{ invalid }" ref="form" tag="div">
                <div class="form-container">
                    <div
                        class="message bh bstart c_666 fz_28 border-bottom"
                        @click="showDialog('isDialog')"
                    >
                        <div class="ico-warning bg-contain"></div>请绑定持卡人本人的银行卡
                    </div>
                    <validation-provider
                        :rules="{required: { allowFalse: false } }"
                        :customMessages="{required:'请上传您本人的银行卡照片'}"
                    >
                        <input class="fz_48" type="hidden" v-model="isUpBank" />
                    </validation-provider>
                    <validation-provider
                        rules="required"
                        v-slot="{ errors }"
                        :customMessages="{required:'请选择所属银行'}"
                    >
                        <zbSelect
                            v-model="formData.bankCardTypeId"
                            :fieldOptions="fieldOptions"
                            :readonly="isUpBank"
                            :vClass="isUpBank&&'border-bottom'"
                            :errorMessage="errors[0]"
                            :data="bankTypeData"
                            showName="bankName"
                            @click="onUpClick($event,'CardBankUp')"
                            @select="onBankSelect"
                        ></zbSelect>
                    </validation-provider>
                    <validation-provider
                        rules="required|bankNo"
                        v-slot="{ errors }"
                        name="银行卡号"
                        v-show="isUpBank"
                    >
                        <van-field
                            v-model="formData.bankCardNumber"
                            clearable
                            maxlength="19"
                            placeholder="请输入银行卡号"
                        >
                            <zb-warning slot="right-icon" :message="errors[0]" />
                        </van-field>
                    </validation-provider>
                </div>
                <div class="bv bc footBar">
                    <van-button
                        :class="getBtnCls(invalid)"
                        @click="onSaveClick"
                        class="btn btn-goodbuy"
                    >
                        <span class="fz_30 btn-span">确认添加</span>
                    </van-button>
                    <van-button @click="go('CardBankList')" class="btn btn-text">
                        <span class="fz_30 c_333">支持银行列表</span>
                    </van-button>
                </div>
            </validation-observer>
        </div>
        <van-overlay class="bh bc" :show="isDialog">
            <div class="dialog-container">
                <div class="dialog-title tc c_black fz_36">持卡人</div>
                <div class="dialog-content fz_30">
                    <div class="bh bstart">
                        姓名：*{{verifiedName}}
                        <div class="tag fz_28 c_white r6">已实名</div>
                    </div>
                    <div class="text">身份证：**************{{idCardNumber}}</div>
                </div>
                <div class="bh bc dialog-bottom">
                    <van-button @click="hiddenDialog('isDialog')" class="btn btn-text">
                        <span class="fz_34 c_warning">好的</span>
                    </van-button>
                </div>
            </div>
        </van-overlay>
    </div>
</template>

<script>
import { bankAdd } from "@/api/money";
import { user } from "@/mixin/user";
import { mixinValid } from "@/mixin/valid";
import { mixinDialog } from "@/mixin/dialog";
import zbSelect from "@/components/input/Select";
import util from "@/utils/index";
export default {
    mixins: [user, mixinValid, mixinDialog],
    name: "UserBankEdit",
    components: { zbSelect },
    data() {
        return {
            formData: {},
            checked: false,
            fieldOptions: {
                placeholder: "请上传您本人的银行卡照片"
            }
        };
    },
    computed: {
        // 认证姓名
        verifiedName() {
            const name = this.verificationInfo.verifiedName || "";
            return util.sliceLast(name, name.length > 2 ? 2 : 1);
        },
        // 认证卡号
        idCardNumber() {
            return util.sliceLast(this.verificationInfo.idCardNumber);
        },
        // 认证信息
        verificationInfo() {
            return this.$store.getters["money/verificationInfo"];
        },
        // 是否上传银行卡
        isUpBank() {
            return this.$store.state.money.isUpBank;
        },
        // 可选银行卡列表
        bankTypeData() {
            return this.$store.getters["money/bankTypeData"];
        },
        // 银行卡认证信息
        bankInfo() {
            return {
                isUp: this.isUpBank,
                data: this.$store.state.money.bankData
            };
        }
    },
    watch: {
        // 更新上传银行卡
        bankInfo: {
            handler(v) {
                if (v.isUp) {
                    const me = this;
                    me.formData = Object.assign({}, me.formData, v.data);
                }
            },
            immediate: true
        }
    },
    methods: {
        // 页面返回
        viewBack() {
            this.$store.state.money.isUpBank = false;
        },
        // 登录成功
        userLoginend() {
            const me = this;
            me.$store.dispatch("money/bankTypeData");
            me.$store.dispatch("money/verificationInfo");
            if (me.$store.state.isDev) {
                me.formData.verifiedTelephone = "18784012064";
            }
        },
        // 更新银行卡名称
        onBankSelect(v) {
            this.formData.bankName = v.text;
        },
        // 点击进入银行卡认证页面
        onUpClick(v, go) {
            if (!v) {
                this.go(go);
            }
        },
        // 保存
        onSaveClick() {
            const me = this;
            me.validForm().then(() => {
                bankAdd(me.formData).then(() => {
                    // 更新认证信息
                    me.$store.dispatch("money/verificationInfo", true);
                    me.$store.dispatch("money/bankList", true);
                    me.$store.state.money.newBankCardNumber =
                        me.formData.bankCardNumber;
                    me.backGo();
                });
            });
        }
    }
};
</script>

<style scoped lang="scss">
.dialog-container {
    @include border-radius(26px);
    width: 510px;
    padding: 40px 20px;
    background-color: #fff;
    .dialog-title {
        padding-bottom: 40px;
        border-bottom: 1px solid #dcdcdc;
    }
    .dialog-content {
        padding: 50px 30px;
        border-bottom: 1px solid #dcdcdc;
        .tag {
            background-color: #ff9a2b;
            padding: 6px;
            margin-left: 20px;
        }
        .text {
            padding-top: 30px;
        }
    }
    .dialog-bottom {
        .btn-text {
            width: 300px;
            margin-top: 40px;
        }
    }
}
.topbar-container {
    background-color: #f7f8f8;
}
.form-container {
    padding: 0 30px;
    background-color: #fff;
}
.message {
    padding: 30px 0;
    background-color: #fff;
    .ico-warning {
        width: 34px;
        height: 34px;
        margin: 3px 12px 0 0;
    }
}
/deep/ .van-cell {
    padding: 40px 0;
}

/deep/.border-bottom {
    &:after {
        left: 0;
        width: 100%;
        border-color: #e5e5e5;
    }
}
.footBar {
    margin-top: 90px;
    .btn-goodbuy {
        width: 510px;
        height: 76px;
    }
    .btn-text {
        margin-top: 10px;
    }
}
</style>
